import type { TableCell } from '@features/powerpoint';
import type { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { postalCodeToStateName } from '@utils/states';

export const ROWS_PER_TABLE = 20;

export const stateVisitRows = (
  stateVisits: CampaignAnalyticsReport['stateVisits']
): TableCell[][] =>
  stateVisits.data
    .toSorted((a, b) => b.visitIndex - a.visitIndex)
    .slice(0, ROWS_PER_TABLE)
    .map((stateVisit, index): TableCell[] => [
      { text: (index + 1).toString(), options: { align: 'left' } },
      {
        text:
          (postalCodeToStateName as Record<string, string>)[
            stateVisit.location
          ] ?? stateVisit.location,
        options: { align: 'left' },
      },
      { text: stateVisit.visitIndex.toString(), options: { align: 'right' } },
    ]);

export const dmaVisitRows = (
  dmaVisits: CampaignAnalyticsReport['dmaVisits']
): TableCell[][] =>
  dmaVisits.data
    .toSorted((a, b) => b.visitIndex - a.visitIndex)
    .slice(0, ROWS_PER_TABLE)
    .map((dmaVisit, index): TableCell[] => [
      { text: (index + 1).toString(), options: { align: 'left' } },
      { text: dmaVisit.location, options: { align: 'left' } },
      { text: dmaVisit.visitIndex.toString(), options: { align: 'right' } },
    ]);

export const brandLocationsRows = (
  brandLocations: CampaignAnalyticsReport['brandLocationVisits']
): TableCell[][] =>
  brandLocations.data
    .toSorted((a, b) => b.index - a.index)
    .slice(0, ROWS_PER_TABLE)
    .map((location, index): TableCell[] => [
      { text: (index + 1).toString(), options: { align: 'left' } },
      { text: location.name.toString(), options: { align: 'left' } },
      { text: location.address.toString(), options: { align: 'left' } },
      { text: location.city.toString(), options: { align: 'left' } },
      { text: location.state.toString(), options: { align: 'left' } },
      { text: location.zip.toString(), options: { align: 'left' } },
      { text: location.index.toString(), options: { align: 'left' } },
    ]);
